import { BUILD_COMMIT, BUILD_DATE, BUILD_DATETIME, BUILD_TIME, BUILD_TIMEZONE, BUILD_VERSION } from '@/generated/build-info';

export type ReleaseEntry = {
  version: string;
  date: string;
  time: string;
  datetime: string;
  timezone: string;
  title: string;
  summary: string;
  items: string[];
  commit?: string;
};

export const releaseEntries: ReleaseEntry[] = [
  {
    version: BUILD_VERSION,
    date: BUILD_DATE,
    time: BUILD_TIME,
    datetime: BUILD_DATETIME,
    timezone: BUILD_TIMEZONE,
    commit: BUILD_COMMIT,
    title: 'Badge visual de release en QA',
    summary: 'QA ahora expone una version visible con numero de cambio, fecha, hora y detalle corto de lo desplegado.',
    items: [
      'Se agrego un boton de version visible en login y dentro del CRM para QA.',
      'Al presionarlo se abre un resumen del cambio con fecha, hora y commit.',
      'El changelog del sistema ahora usa la misma fuente de releases para evitar desalineacion.',
      'La version se genera automaticamente en cada build para que QA vea inmediatamente que despliegue esta usando.',
    ],
  },
  {
    version: '20260418.crm-final-v1',
    date: '2026-04-18',
    time: '13:00',
    datetime: '2026-04-18 13:00:00',
    timezone: 'America/Santiago',
    commit: '58055d4',
    title: 'CRM comercial final v1 en QA demo',
    summary: 'Se cerro el flujo comercial principal con trazabilidad, dashboard ejecutivo y reglas de disciplina comercial en modo QA demo.',
    items: [
      'Flujo Lead a oportunidad con calificacion BANT, descarte y conversion.',
      'Pipeline final con reglas de cierre, proximo paso y motivos de perdida.',
      'Timeline de oportunidad, alertas y performance por vendedor.',
      'Dashboard ejecutivo con forecast, pipeline ponderado y control comercial.',
    ],
  },
  {
    version: '20260412.navigation-drilldown',
    date: '2026-04-12',
    time: '11:00',
    datetime: '2026-04-12 11:00:00',
    timezone: 'America/Santiago',
    title: 'Navegacion de exploracion y documentacion estructurada',
    summary: 'Se habilito drill-down operativo para navegar el CRM con mas contexto y documentacion ordenada.',
    items: [
      'Drill-down del dashboard por metrica.',
      'Vista detalle de empresa con relaciones.',
      'Detalle de lead y oportunidad.',
      'Breadcrumbs mas finos en el sistema.',
      'Docs organizadas en carpetas del proyecto.',
    ],
  },
  {
    version: '20260411.base-funcional',
    date: '2026-04-11',
    time: '10:00',
    datetime: '2026-04-11 10:00:00',
    timezone: 'America/Santiago',
    title: 'Base funcional de CRM',
    summary: 'Primera base operativa del CRM para iterar con demo local.',
    items: [
      'Dashboard, leads, contactos, empresas, oportunidades y actividades.',
      'Persistencia local para demo.',
      'Separacion preliminar de desarrollo y QA.',
    ],
  },
];

export const currentRelease = releaseEntries[0];
